import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase, BLOOD_GROUPS, WARDS, REWARD_POINTS } from '../lib/supabase';

export default function Register() {
  const [form, setForm] = useState({ name: '', blood_group: '', phone: '', ward: '', area: '', age: '', last_donated: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  function validate() {
    const e = {};
    if (!form.name.trim()) e.name = 'പേര് ആവശ്യമാണ്';
    if (!form.blood_group) e.blood_group = 'രക്ത ഗ്രൂപ്പ് ആവശ്യമാണ്';
    if (!form.phone.trim()) e.phone = 'ഫോൺ നമ്പർ ആവശ്യമാണ്';
    else if (!/^[6-9]\d{9}$/.test(form.phone.replace(/\s/g, ''))) e.phone = 'ശരിയായ ഫോൺ നമ്പർ നൽകൂ';
    if (!form.ward) e.ward = 'വാർഡ് ആവശ്യമാണ്';
    if (!form.age) e.age = 'പ്രായം ആവശ്യമാണ്';
    else if (Number(form.age) < 18 || Number(form.age) > 65) e.age = 'പ്രായം 18–65 ആകണം';
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    setErrors({});
    try {
      const { error } = await supabase.from('donors').insert([{
        name: form.name.trim(),
        blood_group: form.blood_group,
        phone: form.phone.trim(),
        ward: form.ward,
        area: form.area.trim() || null,
        age: Number(form.age),
        last_donated: form.last_donated || null,
        is_available: true,
        donated_count: 0,
        points: REWARD_POINTS.REGISTER,
      }]);
      if (error) throw error;
      setSuccess(true);
    } catch (err) {
      console.error('Registration error:', err);
      setErrors({ submit: `രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു: ${err.message || 'വീണ്ടും ശ്രമിക്കൂ.'}` });
    } finally {
      setLoading(false);
    }
  }

  function update(k, v) {
    setForm(f => ({ ...f, [k]: v }));
    if (errors[k]) setErrors(e => { const n = { ...e }; delete n[k]; return n; });
  }

  if (success) {
    return (
      <div className="page-sm">
        <div className="success-screen">
          <div className="success-icon">🩸</div>
          <div className="success-title">നന്ദി! രജിസ്ട്രേഷൻ വിജയകരം</div>
          <p className="success-sub">
            {form.name}, ഡയറക്ടറിയിൽ ചേർത്തിരിക്കുന്നു.<br/>
            <strong style={{ color: 'var(--red)' }}>🎉 +{REWARD_POINTS.REGISTER} പോയിന്റ് ലഭിച്ചു!</strong>
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/donors" className="btn btn-primary">ദാതാക്കളെ കാണൂ</Link>
            <button className="btn btn-outline" onClick={() => { setSuccess(false); setForm({ name: '', blood_group: '', phone: '', ward: '', area: '', age: '', last_donated: '' }); }}>
              മറ്റൊരാളെ ചേർക്കൂ
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-sm">
      <div className="section-header">
        <div>
          <div className="section-title">ദാതാവ് ആകൂ</div>
          <div className="section-sub">നിങ്ങളുടെ വിവരങ്ങൾ ഡയറക്ടറിയിൽ ചേർക്കൂ</div>
        </div>
      </div>

      <div className="alert alert-success" style={{ marginBottom: 16 }}>
        <span>🎁</span>
        <span>രജിസ്ട്രേഷനിൽ <strong>+{REWARD_POINTS.REGISTER} പോയിന്റ്</strong> ഉടൻ ലഭിക്കും!</span>
      </div>

      <div className="alert alert-info">
        <span>ℹ️</span>
        <span>18–65 വയസ്സ്, 50 കി.ഗ്രാ. ഭാരം, ആരോഗ്യമുള്ളവർക്ക് ദാനം ചെയ്യാം.</span>
      </div>

      <div className="card">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">പേര് *</label>
              <input className="form-input" type="text" placeholder="പൂർണ്ണ പേര്" value={form.name} onChange={e => update('name', e.target.value)} />
              {errors.name && <div className="form-error">{errors.name}</div>}
            </div>
            <div className="form-group">
              <label className="form-label">രക്ത ഗ്രൂപ്പ് *</label>
              <select className="form-select" value={form.blood_group} onChange={e => update('blood_group', e.target.value)}>
                <option value="">തിരഞ്ഞെടുക്കൂ</option>
                {BLOOD_GROUPS.map(g => <option key={g} value={g}>{g}</option>)}
              </select>
              {errors.blood_group && <div className="form-error">{errors.blood_group}</div>}
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">ഫോൺ നമ്പർ *</label>
              <input className="form-input" type="tel" placeholder="98765 43210" value={form.phone} onChange={e => update('phone', e.target.value)} />
              {errors.phone && <div className="form-error">{errors.phone}</div>}
              <div className="form-hint">ഈ നമ്പർ പൊതു ഡയറക്ടറിയിൽ കാണിക്കില്ല. ആവശ്യക്കാർ ബട്ടൺ അമർത്തിയാൽ മാത്രം കണക്ഷൻ ലഭിക്കും.</div>
            </div>
            <div className="form-group">
              <label className="form-label">പ്രായം *</label>
              <input className="form-input" type="number" placeholder="25" min="18" max="65" value={form.age} onChange={e => update('age', e.target.value)} />
              {errors.age && <div className="form-error">{errors.age}</div>}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">വാർഡ് നമ്പർ *</label>
            <select className="form-select" value={form.ward} onChange={e => update('ward', e.target.value)}>
              <option value="">വാർഡ് തിരഞ്ഞെടുക്കൂ</option>
              {WARDS.map(w => <option key={w} value={w}>{w}</option>)}
            </select>
            {errors.ward && <div className="form-error">{errors.ward}</div>}
          </div>
          <div className="form-group">
            <label className="form-label">സ്ഥലം / ഏരിയ</label>
            <input className="form-input" type="text" placeholder="ഉദാ: കോളനി, ജംഗ്ഷൻ…" value={form.area} onChange={e => update('area', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">അവസാനം രക്തം ദാനം ചെയ്ത തീയതി</label>
            <input className="form-input" type="date" value={form.last_donated} onChange={e => update('last_donated', e.target.value)} max={new Date().toISOString().split('T')[0]} />
            <div className="form-hint">ഇല്ലെങ്കിൽ ഒഴിവാക്കൂ</div>
          </div>
          {errors.submit && <div className="alert alert-danger" style={{ marginBottom: 16 }}><span>⚠️</span> {errors.submit}</div>}
          <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading}>
            {loading ? <><div className="spinner" style={{ width: 16, height: 16 }}></div> ചേർക്കുന്നു…</> : '🩸 ഡയറക്ടറിയിൽ ചേർക്കൂ'}
          </button>
        </form>
      </div>
    </div>
  );
}
